import {Component, EventEmitter, Output} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ValidationErrors, Validators} from "@angular/forms";
import {v4 as uuidv4} from "uuid";
import {debounceTime, Subject, takeUntil} from "rxjs";
import {CommonService} from "../../../../shared/services/common.service";
import {DomSanitizer} from "@angular/platform-browser";
import {ResourcesHubService} from "../../core/resources-hub.service";

@Component({
  selector: 'app-add-video',
  templateUrl: './add-video.component.html',
  styleUrls: ['./add-video.component.css']
})
export class AddVideoComponent {
  layoutData: any;
  data: any
  @Output() layoutDataChangedEmitter: EventEmitter<any> = new EventEmitter()
  videoForm: FormGroup = new FormGroup({
    videoUrl: new FormControl('', [Validators.required])
  }, {validators: [this.validateLink]});
  errorMessages: any = {};
  errorMessageMap = {
    videoUrl: {
      required: 'This field is required',
      linkValidation: 'Only Vimeo and Youtube embedded link is allowed'
    },
  }
  showPreview: boolean = false;
  UUID = uuidv4();
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(private commonService: CommonService, private domSanitizer: DomSanitizer, private resourceHubService: ResourcesHubService) {
  }

  ngOnInit(): void {
    this.layoutData = this.data.layoutData;
    this.videoForm.patchValue({videoUrl: this.layoutData.videoUrl}, {emitEvent: false})
    this.checkForErrors();
    if (this.videoForm.valid) {
      this.showPreview = true
    } else {
      this.showPreview = false;
    }
    this.videoForm.valueChanges.pipe(takeUntil(this.onDestroy), debounceTime(1000)).subscribe(values => {
      const updatedLayoutData = {
        ...this.layoutData,
        ...values
      }
      this.resourceHubService.sendDataToParent({
        sectionUuid: this.data.sectionUuid,
        contentUuid: this.data.contentUuid,
        layoutData: updatedLayoutData,
        currentComponentIndex: this.data.currentComponentIndex,
      })

      this.resourceHubService.setLastUpdatedId(null)

      if (this.videoForm.invalid) {
        this.checkForErrors();
        this.showPreview = false;
        return
      }
    })
  }

  ngAfterViewChecked(): void {
    if (this.videoForm.valid) {
      const videoWrapper = $('.video-wrapper-' + this.UUID);
      if (videoWrapper && videoWrapper?.get(0)?.getBoundingClientRect()?.width) {
        const slideWidth = videoWrapper?.get(0)?.getBoundingClientRect()?.width
        const iframe = $(`.video-wrapper-${this.UUID} iframe`);
        iframe.get(0)?.setAttribute('width', slideWidth.toString());
        iframe.get(0)?.removeAttribute('height');
        iframe.css('aspect-ratio', '4/3');
      }
    }
  }

  getSanitizedContent(content) {
    return this.domSanitizer.bypassSecurityTrustHtml(content);
  }


  validateLink(control: AbstractControl): ValidationErrors | null {
    if (control && control.get('videoUrl')) {
      const videoUrl: string = control.get('videoUrl').value;
      if (videoUrl) {
        if (!videoUrl.includes('<iframe') || !videoUrl.includes('</iframe>')) {
          control.get('videoUrl').setErrors({
            ...(control.get('videoUrl').errors ? control.get('videoUrl').errors : {}),
            linkValidation: true
          })
        } else if (!videoUrl.includes('src="https://www.youtube.com/embed/') && !videoUrl.includes('src="https://player.vimeo.com/video')) {
          control.get('videoUrl').setErrors({
            ...(control.get('videoUrl').errors ? control.get('videoUrl').errors : {}),
            linkValidation: true
          })
        }
      } else if (!videoUrl) {
        control.get('videoUrl').setErrors({
          ...(control.get('videoUrl').errors ? control.get('videoUrl').errors : {}),
          required: true
        })
      }
    }
    return null;
  }


  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.videoForm, this.errorMessageMap, currentField))
    };
  }

  deleteGoogleSlidesLink() {
    this.showPreview = false;
    this.videoForm.setValue({
      videoUrl: ""
    })
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }


}
